import React from 'react';
import PropTypes from 'prop-types';

import { trackV2 } from '@gumtree/shared/src/util/track-ga-event';
import Icon from '../icon/icon';

import './zoom.scss';

const Zoom = ({ openDialog, currentSlide }) => (
    <button
        type="button"
        className="carousel-open"
        onClick={() => {
            trackV2('SliderFullScreen', 'loop');
            openDialog(currentSlide);
        }}
    >
        <Icon type="magnifying-glass-zoom" />
    </button>
);

Zoom.propTypes = {
    currentSlide: PropTypes.number,
    openDialog: PropTypes.func,
};

Zoom.defaultProps = {
    currentSlide: 1,
    openDialog: () => {},
};

export default Zoom;
